import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { GetChannels } from '../../../../../core/shared/actions/channel.actions';
import { GetGroupsByapplication } from '../../../../../core/shared/actions/group.actions';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { Channel } from '../../../../../core/shared/models/channel.model';
import { Group } from '../../../../../core/shared/models/group.model';
import { ChannelState } from '../../../../../core/shared/states/channel.state';
import {
  AssignGroupToChannel,
  DeleteGroupAssignment,
} from '../../../../../core/shared/actions/group.assignment.actions';
import { GroupState } from '../../../../../core/shared/states/group.state';
import { SubscriptionModel } from '../../../../../core/shared/models/subscription.model';
@Component({
  selector: 'app-developer-application-subscription-modal',
  templateUrl: './developer-application-subscription-modal.component.html',
  styleUrls: ['./developer-application-subscription-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatFormField, MatLabel, MatInput, MatError, MatSelect, MatOption, MatIcon, MatButton, MatIconButton,
  ],
})
export class DeveloperApplicationSubscriptionModalComponent {
  @Input() public applicationName!: string;
  @Input() public formMode = 'New';
  @Input() public editSubscription = false;
  @Input() public subscription?: SubscriptionModel;
  private formSubscription: Subscription = new Subscription();
  groups: Observable<Group[]>;
  channels: Observable<Channel[]>;
  groupList: Group[] = [];
  channelList: Channel[] = [];
  entryForm!: FormGroup;
  error: string | undefined;
  id: any;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private store: Store
  ) {
    this.channels = this.store.select(ChannelState.getChannelList);
    this.groups = this.store.select(GroupState.getGroupList);
    this.createForm();
  }

  ngOnInit() {
    this.store.dispatch(new GetGroupsByapplication(this.applicationName));
    this.store.dispatch(new GetChannels(this.applicationName, 'test'));

    this.groups.subscribe((groups) => {
      this.groupList = groups;
      // only default to the first group when creating a new subscription, never override an edit
      if (!this.subscription && this.groupList.length > 0) {
        this.entryForm.patchValue({ group_name: this.groupList[0].group_name });
      }
    });
    this.channels.subscribe((channels) => {
      this.channelList = channels;
      // only default to the first channel when creating a new subscription, never override an edit
      if (!this.subscription && this.channelList.length > 0) {
        this.entryForm.patchValue({
          channel_name: this.channelList[0].channel_name,
        });
      }
    });

    if (this.subscription) {
      this.entryForm.patchValue({
        group_name: this.subscription.group_name,
        channel_name: this.subscription.channel_name,
        Description: this.subscription.Description,
      });

      this.editSubscription = true;
    } else {
      this.editSubscription = false;
    }
  }

  //   // Handle Create  update button click
  onCreate_Update(): void {
    this.formSubscription.add(
      this.store
        .dispatch(
          new AssignGroupToChannel(this.applicationName, this.entryForm.value)
        )
        .subscribe(
          (resp: any) => {
            this.activeModal.close();
            this.showSnackBar('Subscription added successfully!', false);
          },
          (error) => {
            this.activeModal.close();
            this.showSnackBar('An error occurred:' + error.error.message, true);
          }
        )
    );
  }
  // Handle Create button click

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(
        new DeleteGroupAssignment(
          this.entryForm.controls['channel_name'].value,
          this.entryForm.controls['group_name'].value
        )
      )
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar(
            'The Subscription has been successfully deleted!!',
            false
          );
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }

  public changeGroup(e: any): void {
    const find = this.groupList.find((x) => x?.group_name === e.target.value);
  }

  public changeChannel(e: any): void {
    const find = this.channelList.find(
      (x) => x?.channel_name === e.target.value
    );
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      group_name: new FormControl('', [Validators.required]),
      channel_name: new FormControl('', [Validators.required]),
      Description: new FormControl('', [Validators.required]),
    });
  }

  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }
  clearForm() {
    this.entryForm.reset();
  }
}
